import styled from 'styled-components';
import { Typography, Select, TextField } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';

export const GridWrapper = styled.div`
  margin: 10px;
`;

export const Title = styled(Typography)`
  text-align: left;
  font-size: 24px;
  letter-spacing: 0;
  margin-left: 10px;
  margin-bottom: 40px;
  color: #2b2727;
  font-weight: 500;
  font-family: Roboto;
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
`;

export const StyledTextField = styled(TextField)`
  .MuiInputBase-input.Mui-disabled {
    font-weight: 500;
  }
`;

export const StyledKeyboardDatePicker = styled(KeyboardDatePicker)`
  .MuiInputBase-input.Mui-disabled {
    font-weight: 500;
  }
`;

export const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .subContainer {
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
  }
  .smallSubContainer {
    display: flex;
    margin-top: 25px;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
  }
  .input-3 {
    width: 32%;
    margin-bottom: 33px;
  }
  .input-4 {
    width: 27%;
    margin-left: 30px;
    margin-bottom: 33px;
  }
  .checkdiv {
    align-items: center;
    display: flex;
    margin-left: 10px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #2b2727;
    margin-right: 17px;
    font-weight: Bold;
    font-family: Roboto;
  }
  .hideContent {
    visibility: hidden;
  }
  .label-input {
    font-size: 20px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
  .MuiInputLabel-shrink {
    font-size: 20px;
    color: #666;
  }
`;
